import { useQuery } from "@tanstack/react-query";
import { QuestionnaireApi } from "../questionnaire.api";
import { questionnaireKeys } from "./questionnaire.keys";

export const useQuestionnaireLatestInstanceQuery = (
  contextType?: string,
  contextId?: string,
  questionnaireSlug?: string
) => {
  return useQuery({
    queryKey: questionnaireKeys.latestInstance(
      contextType ?? "",
      contextId ?? "",
      questionnaireSlug
    ),
    queryFn: () =>
      QuestionnaireApi.getLatestInstance(
        contextType!,
        contextId!,
        questionnaireSlug
      ),
    enabled: Boolean(contextType && contextId),
    staleTime: 30_000,
  });
};
